import toast, { ToastOptions } from "react-hot-toast";

export const RECORD_LIMIT = 10;
export const ToastPosition = {
    TOP_LEFT: "top-left",
    TOP_CENTER: "top-center",
    TOP_RIGHT: "top-right",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_CENTER: "bottom-center",
    BOTTOM_RIGHT: "bottom-right",
  } as const;

  export const ToastType = {
    SUCCESS: "success",
    ERROR: "error",
  } as const;
  
  export type ToastTypeKey = keyof typeof ToastType;
  export type ToastPositionType = keyof typeof ToastPosition;

  export const AzureErrorCode = {
    INTERACTION_IN_PROGRESS: "interaction_in_progress", // Authentication flow is already in progress
    POPUP_CLOSED_BY_USER: "popup_closed_by_user",       // User closed the popup before completing the login
    USER_CANCELLED: "user_cancelled",                  // User canceled the operation
    NO_ACCOUNT: "no_account",                          // No account available for silent login
    TOKEN_ACQUISITION_FAILED: "token_acquisition_failed", // Failed to acquire token
    INVALID_GRANT: "invalid_grant",                    // Invalid credentials or session expired
    NETWORK_ERROR: "network_error",                    // Network issue during authentication
    CLIENT_AUTH_ERROR: "client_authentication_error",  // Client authentication failure
    TIMEOUT: "timeout",                                // Operation timed out
    UNEXPECTED_ERROR: "unexpected_error",              // Catch-all for unexpected errors
  } as const;
  
  export const AzureErrorMessages = {
    [AzureErrorCode.INTERACTION_IN_PROGRESS]: "A login process is already in progress. Please complete it before trying again.",
    [AzureErrorCode.POPUP_CLOSED_BY_USER]: "Login popup was closed. Please try again.",
    [AzureErrorCode.USER_CANCELLED]: "Login popup was closed. Please try again..",
    [AzureErrorCode.NETWORK_ERROR]: "A network error occurred. Please check your internet connection and try again.",
    [AzureErrorCode.INVALID_GRANT]: "Your session has expired or the provided credentials are invalid. Please log in again.",
    [AzureErrorCode.CLIENT_AUTH_ERROR]: "An authentication error occurred. Please contact support if this persists.",
    [AzureErrorCode.TIMEOUT]: "The login process timed out. Please try again.",
    [AzureErrorCode.TOKEN_ACQUISITION_FAILED]: "Failed to acquire the authentication token. Please refresh the page and try again.",
    [AzureErrorCode.NO_ACCOUNT]: "No user account is available for this operation. Please ensure you are logged in.",
    [AzureErrorCode.UNEXPECTED_ERROR]: "An unexpected error occurred during login. Please try again or contact support.",
  };
  export const getErrorMessage = (errorCode: keyof typeof AzureErrorMessages) => {
    return AzureErrorMessages[errorCode] || AzureErrorMessages[AzureErrorCode.UNEXPECTED_ERROR];
  };

  export const RouteFlagConstant = {
    FORMS: 1,
    QUIZ: 2,
    POLL: 3,
  } as const;

  interface ShowToastProps {
  message: string;
  type: ToastTypeKey;
  position?: ToastPositionType;
}

export const ToastTypeCode = {
  SUCCESS: "SUCCESS", 
  ERROR: "ERROR"
} as const;

export const RoleTypeCode = {
  SuperAdmin: "Super Admin", 
  Responder: "Responder", 
  User: "User", 
  Coordinator: "Coordinator", 
  Administrator: "Administrator"
} as const;

export const showToast = ( message :string, type:string) => {

  if (type === ToastTypeCode?.SUCCESS) {
    toast.success(message, { position:ToastPosition?.TOP_RIGHT });
  } else if (type ===  ToastTypeCode?.ERROR) {
    toast.error(message, { position: ToastPosition?.TOP_RIGHT });
  } else {
    console.error("Invalid toast type provided!");
  }
};

export const userIdForPublicSurvey = 2147483647;